
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { LogOut } from 'lucide-react';
import { useHeaderAuth } from '@/hooks/useHeaderAuth';

interface AuthButtonsProps {
  isLoggedIn: boolean;
}

export const AuthButtons: React.FC<AuthButtonsProps> = ({ isLoggedIn }) => {
  const { isLoading, handleLogout } = useHeaderAuth();

  if (isLoggedIn) {
    return (
      <Button 
        variant="outline" 
        className="border-white text-white hover:bg-white hover:text-primary-blue"
        onClick={handleLogout}
        disabled={isLoading}
      >
        {isLoading ? (
          <div className="flex items-center">
            <div className="h-4 w-4 animate-spin rounded-full border-2 border-b-transparent mr-2" />
            Logging out...
          </div>
        ) : (
          <>
            <LogOut className="mr-2 h-4 w-4" />
            Logout
          </>
        )}
      </Button>
    );
  }

  return (
    <div className="flex items-center space-x-4">
      <Link to="/login" className="text-white hover:text-gray-200">
        Login
      </Link>
      <Link to="/business-signup" onClick={() => window.scrollTo(0, 0)}>
        <Button variant="outline" className="border-white text-white hover:bg-white hover:text-primary-blue">
          Sign Up
        </Button>
      </Link>
    </div>
  );
};
